import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=07aa9961&scoped=true"
var script = {}
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=07aa9961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa9961",
  null
  
)

export default component.exports